module.exports = __webpack_public_path__ + "img/cursor-drag-node.c3ec7993.png";